import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAcclaimComponent } from './simple-icons-acclaim.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAcclaimComponent ],
    exports:      [ SimpleIconsAcclaimComponent ],
    bootstrap:    []
})
export class SimpleIconsAcclaimModule {}
